/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */

/**
 * This is our repository factory
 * we will use this factory to access all Repositories that
 * we use inside the app
 * the repository design pattern is to create abstraction on top of all the api calls
 * that will be executed during the app lifetime. This pattern is decoupled from the app
 * and allows us to switch to different technology easily
 */
import AddressRepository from "./AddressRepository";
import AuthRepository from "./AuthRepository";
import BusinessRepository from "./BusinessRepository";
import LookupRepository from "./LookupRepository";
import StatRepository from "./StatisticsRepository";
import MembershipRepository from "./MembershipRepository";

import TRepository from "./TRepository";
import SettingsRepository from "./SettingsRepository";
import LanguagesRepo from "./LanguagesRepo";

import LogoutRepository from "./LogoutRepository";
import DiagnosticRepository from "./DiagnosticRepository";
import DeliveryRepository from "./DeliveryRepository";
import MenuRepository from "./menuRepository"
import CouponsRepository from "./CouponsRepository"
import ReportsRepository from "./ReportsRepository"
import PriceListRepository from "./PriceListRepository";
import MpServiceRepository from "./MpServiceRepository";

const repositories = {
    auth: AuthRepository,
    business: BusinessRepository,
    membership: MembershipRepository,
    lookup: LookupRepository,
    address: AddressRepository,
    stat: StatRepository,
    tRepo: TRepository,
    settingsRepo: SettingsRepository,
    logoutRepo: LogoutRepository,
    diagnosticRepo: DiagnosticRepository,
    DeliveryAreas: DeliveryRepository,
    menu: MenuRepository,
    coupons: CouponsRepository,
    reports: ReportsRepository,
    priceList: PriceListRepository,
    languages: LanguagesRepo,
    mpService: MpServiceRepository
};

export default {
    get: (name) => repositories[name],
};
